<template>
	<div class="slider-pillars">
		<swiper :options="swiperOption">
			<swiper-slide  v-for="item in imgsPillars" :key="item.id">
				<div :style="{ backgroundImage: `url(${item.backgroundImage})`}" class="image">
					<div class="slider-images">
						<div class="mb-4">
							<p class="number-pillars">{{ item.number }}</p>
							<p class="bar-pillars"></p>
							<p class="title-pillars">{{ item.title }} <br><span class="text-fs">{{ item.title42 }}</span> </p>
						</div>
						<div>
							<div class="content-slider">
								<p>{{ item.content }}</p>
							</div>
						</div>
					</div>
				</div>
			</swiper-slide>
			<div class="swiper-button-prev" slot="button-prev"></div>
			<div class="swiper-button-next" slot="button-next"></div>
			<div class="swiper-pagination" slot="pagination"></div>
		</swiper>
	</div>
</template>

<script>
import 'swiper/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

function data() {
	return {
		imgsPillars: [
			{
				id: 1,
				backgroundImage: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/image-pillars-1.png',
				title: 'CONOCIMIENTO',
				title42: 'DEL NEGOCIO',
				content: 'Si no conocemos el negocio no podemos tener éxito en esto, somos curiosos, apasionados por lo que hacemos.Queremos usar tecnología para impactar los negocios del mundo y simplificarle la vida a los soñadores(empresarios) como nosotros. ',
				number: 1,
			},
			{
				id: 2,
				title: 'DESARROLLO',
				title42: 'TECNOLÓGICO',
				backgroundImage: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/image-billars-2.png',
				content: 'Estamos un paso adelante en cuanto a tecnología se trata, no queremos estar en nuestra zona de confort, nosotros vamos por más.',
				number: 2,
			},
			{
				id: 3,
				title: 'DESARROLLO',
				title42: 'COMERCIAL',
				backgroundImage: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/image-billars-3.png',
				content: 'Somos disruptivos, estamos acostumbrados a romper los paradignas, a pensar diferente e ir por el atajo en lugar del camino frecuente, nos distingue nuestra nueva forma de pensar, la misma que usamos para crear productos exitosos',
				number: 3,
			},
		],
		swiperOption: {
			spaceBetween: 0,
			centeredSlides: true,
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		},
	};
}

export default {
	name: 'slider-pillars',
	data,
	components: {
		swiperSlide,
		swiper,
	},
};
</script>

<style lang="scss" scoped>
.slider-pillars {
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	width: 100%;
}

.number-pillars {
	color: map-get($colors, white);
	font-family: 'Lato', sans-serif;
	font-weight: 900;
	font-size: 120px;

	@media (max-width: 1024px) {
		font-size: 72px;
	}
}

.title-pillars {
	color: map-get($colors, white);
	font-family: 'Lato', sans-serif;
	font-weight: 900;
	font-size: 36px;
	padding-left: 17px;
	max-width: 300px;

	@media (max-width: 1024px) {
		font-size: 22px;
		max-width: 287px;
	}
}

.content-slider {
	border: 1px solid white;
	color: map-get($colors, white);
	font-family: 'Lato', sans-serif;
	font-weight: 400;
	font-size: 24px;
	padding: 62px 50px;

	@media (max-width: 1024px) {
		font-size: map-get($sizes, xlarge);
		font-family: 'Lato', sans-serif;
		font-weight: 400;
		height: 337px;
		padding: 32px 15px;
	}
}

.bar-pillars {
	background-color: map-get($colors, white);
	height: 109px;
	margin-left: 17px;
	width: 2px;

	@media (max-width: 1024px) {
		height: 60px;
		margin-top: 15px;
	}
}

.text-fs {
	font-size: 42px;

	@media (max-width: 1024px) {
		font-size: 28px;
	}
}

.mb-4 {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	margin-bottom: 45px;
}

.image {
	height: 100vh;
	padding:  185px 37px;

	@media (max-width: 1024px) {
		height: 640px;
		padding: 87px 50px;
	}
}

.slider-images {
	align-items: center;
	display: flex;
	flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/components/pillars/slider-pillars.vue